import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36218f40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: ".container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { randomMenus } from "@/assets/constants/constants";
import { reactive } from "@vue/reactivity";
import { onMounted, watchEffect } from "@vue/runtime-core";
import { getRandomNum } from "@/hooks/useRandomMenu";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const limit = randomMenus.length;

const state = reactive({
  rolling: false,
  menuName: "",
});

onMounted(() => {
  state.menuName = "";
});

const stop = watchEffect(() => {
  loop();
});

async function loop() {
  while (state.rolling) {
    const newMenu = await rollMenus();
    state.menuName = newMenu as string;
  }
}

function rollMenus() {
  return new Promise((resolve) =>
    setTimeout(() => {
      resolve(randomMenus[getRandomNum(0, limit - 1)]);
    }, 40)
  );
}

const handleRollingMenus = () => {
  state.rolling = !state.rolling;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "random-menu",
      onClick: handleRollingMenus
    }, [
      (!_unref(state).menuName)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "랜덤 메뉴 추천!"))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(state).menuName), 1))
    ])
  ]))
}
}

})